import type { Config } from 'eslint/config';
import { esmRulesConfig } from '../rules/index.js';

export const esmConfig: Config[] = [esmRulesConfig];
